export default __webpack_public_path__ + "static/media/rect.518d0620.png";